// extracted by mini-css-extract-plugin
module.exports = {"loader":"NewUserCard_loader__VenuD","load3":"NewUserCard_load3__1ZNUa"};